import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { loadAllUsers } from 'actions/user';

export const PartnerSpoof = ({ history }) => {
    const dispatch = useDispatch();

    const { user, allUsers } = useSelector(state => state.user);

    React.useEffect(() => {
        !user.companySettings?.prism_UI && user?.partner_Id > 0 && dispatch(loadAllUsers());
    }, [user]);

    if (user.companySettings?.prism_UI || (!user?.partner_Id && !user?.spoofing)) {
        return null;
    }

    return (
        <div className="inline-block" id="spoof-bar">
            <div className="inline-block partner-bar text-center p5">
                PARTNER<span className="hidden-xs inline-block-md">&nbsp;PORTAL</span>
                {user.spoofing && <span> - SPOOFING</span>}
                {user.partner_Id > 0 && (
                    <div className="inline-block partner-users">
                        <select
                            className="form-control"
                            onChange={e =>
                                history.push?.(
                                    `/spoofing?email=${encodeURIComponent(e.target[e.target.selectedIndex].value)}`
                                )
                            }
                        >
                            <option>--select user to spoof--</option>
                            {allUsers &&
                                allUsers
                                    .filter(u => u.licence === 'FULL')
                                    .sort((a, b) => a.full_Name.localeCompare(b.full_Name))
                                    .map(u => (
                                        <option key={`user-${u.id}`} value={u.email}>
                                            {u.full_Name}
                                        </option>
                                    ))}
                        </select>
                    </div>
                )}
            </div>
        </div>
    );
};

export default withRouter(PartnerSpoof);
